module.exports = __webpack_public_path__ + "static/media/DuplicateSans.3a1587e9.woff";